<template>
  <div class="col-12 col-lg-6">
    <div class="tit text-center">
      <h1>Sexo</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="Genre">Sexo</label>
            <at-select v-model="currentUser.Pessoal.Sexo" filterable size="large" required placeholder="Selecione...">
              <at-option v-for="(genre, index) in optionsGenre" :key="`genreOptions${index}`" :value="genre.value">{{genre.label}}</at-option>        
            </at-select>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      optionsGenre : [
        {value: 1, label: "Masculino"},
        {value: 2, label: "Feminino"}
      ]
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {Pessoal: this.currentUser.Pessoal}
      this.$emit('on-submit', newData)
    }
  },
  mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/GenreStep.vue